module.exports = __webpack_public_path__ + "img/swiper_04.1fd24d73.jpg";